import { ArchiveSvg } from 'assets/dashboard/ArchiveSvg';
import { BillingSvg } from 'assets/dashboard/BillingSvg';
import { DashboardSvg } from 'assets/dashboard/DashboardSvg';
import { DepartmentSvg } from 'assets/dashboard/DepartmentSvg';
import { FinanceRequestSvg } from 'assets/dashboard/FinanceRequestSvg';
import { InventorySvg } from 'assets/dashboard/InventorySvg';
import { ProjectManagementSvg } from 'assets/dashboard/ProjectManagementSvg';
import { ProjectsSvg } from 'assets/dashboard/ProjectsSvg';
import { QuizSvg } from 'assets/dashboard/QuizSvg';
import { ReportsSvg } from 'assets/dashboard/ReportsSvg';
import { SalesSvg } from 'assets/dashboard/SalesSvg';
import { SettingsSvg } from 'assets/dashboard/SettingsSvg';
import { TeamsSvg } from 'assets/dashboard/TeamsSvg';
import { UserManagementSvg } from 'assets/dashboard/UserManagementSvg';
import { SYSTEM_USERS } from 'constants/constants';

const userType = localStorage.getItem('userType');

const settingsToPath =
  userType === 'Hr Manager' ? '/settings/schedules' : '/settings/sales-salary';

const hasAccess = (roles = []) => roles.includes('*') || roles.includes(userType);

const archiveSubmenu = [
  {
    name: 'Departments',
    route: '/archive/departments',
    roles: ['Super Admin', 'Hr Manager', 'Department Head', ...SYSTEM_USERS],
  },
  {
    name: 'Branches',
    route: '/archive/branches',
    roles: ['Super Admin', 'Hr Manager', 'Branch Head', 'Department Head', ...SYSTEM_USERS],
  },
  {
    name: 'Teams',
    route: '/archive/teams',
    roles: [
      'Super Admin',
      'Hr Manager',
      'Team Lead',
      'Branch Head',
      'Department Head',
      ...SYSTEM_USERS,
    ],
  },
  {
    name: 'Users',
    route: '/archive/users',
    roles: ['Super Admin', 'Hr Manager', ...SYSTEM_USERS],
  },
];

const archiveDefaultTo =
  archiveSubmenu.find((item) => hasAccess(item.roles))?.route ?? '/archive/departments';

export const SIDEBAR_ITEMS = [
  {
    name: 'Dashboard',
    icon: DashboardSvg,
    route: '/dashboard',
    roles: ['*'],
  },
  {
    name: 'User Management',
    icon: UserManagementSvg,
    route: '/user-management?limit=10&offset=0&view=list',
    roles: ['*'],
  },
  {
    name: 'Project Management',
    icon: ProjectManagementSvg,
    route: '/project-management',
    roles: ['*'],
    submenu: [
      {
        name: 'Tickets',
        route: ['/project-management/tickets', '/project-management/ticket'],
        roles: ['*'],
      },
      {
        name: 'Appointments',
        route: ['/project-management/appointment'],
        roles: ['*'],
      },
    ],
  },
  {
    name: 'Archive',
    route: '/archive',
    to: archiveDefaultTo,
    icon: ArchiveSvg,
    roles: [
      'Super Admin',
      'Hr Manager',
      'Team Lead',
      'Department Head',
      'Branch Head',
      ...SYSTEM_USERS,
    ],
    submenu: archiveSubmenu,
  },
  {
    name: 'Departments',
    route: '/departments',
    icon: DepartmentSvg,
    roles: ['Super Admin', 'Hr Manager', 'Department Head', ...SYSTEM_USERS],
    submenu: [
      {
        name: 'Branches',
        route: '/departments/branches',
        roles: ['Super Admin', 'Hr Manager', 'Branch Head', ...SYSTEM_USERS],
        submenu: [
          {
            name: 'Teams',
            route: '/departments/branches/teams',
            roles: ['Super Admin', 'Hr Manager', 'Team Lead', ...SYSTEM_USERS],
          },
        ],
      },
    ],
  },
  {
    name: 'Branches',
    route: '/departments/branches',
    roles: ['Branch Head'],

    icon: DepartmentSvg,
  },
  {
    name: 'Teams',
    route: '/departments/branches/teams',
    roles: ['Team Lead'],
    icon: DepartmentSvg,
  },
  {
    name: 'Projects',
    to: '/project/types',
    route: '/project/',
    icon: ProjectsSvg,
    roles: ['Super Admin', 'Hr Manager', ...SYSTEM_USERS],
    submenu: [
      { name: 'Projects', route: '/project/projects', roles: ['*'] },
      { name: 'Types', route: '/project/types', roles: ['*'] },
    ],
  },
  {
    name: 'Teams',
    icon: TeamsSvg,
    route: '/team-management',
    roles: ['Super Admin', 'Hr Manager', ...SYSTEM_USERS],
  },
  {
    name: 'Billing Reports',
    icon: BillingSvg,
    route: '/billing',
    to: '/billing/subscribers',
    roles: ['Super Admin'],
    submenu: [
      { name: `Subscriber's`, route: '/billing/subscribers', roles: ['Super Admin'] },
      { name: 'Payment', route: '/billing/payment', roles: ['Super Admin'] },
      { name: 'Request', route: '/billing/request', roles: ['Super Admin'] },
      { name: 'Comparison', route: '/billing/comparison', roles: ['Super Admin'] },
      { name: 'Daily', route: '/billing/daily', roles: ['Super Admin'] },
      { name: 'Export', route: '/billing/export', roles: ['Super Admin'] },
      { name: 'B2C', route: '/billing/b2c', roles: ['Super Admin'] },
      { name: 'B2B', route: '/billing/b2b', roles: ['Super Admin'] },
      {
        name: 'Marketing Reports',
        route: '/billing/marketingReports',
        roles: ['Super Admin'],
      },
    ],
  },
  {
    name: 'Statement',
    to: '/statement/payment-report',
    icon: BillingSvg,
    route: '/statement',
    roles: ['Super Admin', 'Accounting Staff', 'General Manager'],
    submenu: [
      {
        name: 'Payment Report',
        route: '/statement/payment-report',
        roles: ['General Manager', 'Super Admin', 'Accounting Staff'],
      },
      {
        name: 'Subscribers',
        route: '/statement/subscribers',
        roles: ['General Manager', 'Super Admin', 'Hr Manager'],
      },
    ],
  },
  {
    name: 'Settings',
    to: '/settings/schedules',
    icon: SettingsSvg,
    route: '/settings',
    roles: ['Super Admin', 'Hr Manager', 'General Manager'],
    submenu: [
      {
        name: 'Schedules',
        route: '/settings/schedules',
        roles: ['General Manager', 'Super Admin', 'Hr Manager'],
      },
      {
        name: 'Sales Settings',
        route: '/settings/sales-salary',
        roles: ['General Manager', 'Super Admin', 'Hr Manager'],
      },
      {
        name: 'Unified Communication',
        route: '/settings/chat',
        roles: ['General Manager', 'Super Admin'],
      },
    ],
  },
  {
    name: 'Reports',
    icon: ReportsSvg,
    route: '/reports',
    to: '/reports/payroll',
    roles: ['*'],
    submenu: [{ name: 'Payroll report', route: '/reports/payroll', roles: ['*'] }],
  },
  {
    name: 'Inventory',
    icon: InventorySvg,
    route: '/inventory',
    to: '/inventory/categories?view=table',
    roles: ['Super Admin', 'General Manager', 'Department Head'],
    submenu: [
      {
        name: 'Categories',
        route: '/inventory/categories',
        roles: ['General Manager', 'Super Admin'],
      },
      {
        name: 'Request history',
        route: '/inventory/request-history',
        roles: ['Super Admin', 'General Manager', 'Department Head'],
      },
      {
        name: 'Employee Inventory',
        route: '/inventory/employee-inventory',
        roles: ['Super Admin', 'General Manager', 'Department Head'],
      },
      {
        name: 'Returned Items',
        route: '/inventory/returnedItems',
        roles: ['Super Admin', 'General Manager', 'Department Head'],
      },
    ],
  },
  {
    name: 'Sales',
    icon: SalesSvg,
    route: '/sales',
    to: '/sales',
    roles: ['*'],
    submenu: [
      {
        name: 'Add Lead',
        route: '/sales/search-lead',
        roles: ['*'],
      },
      // {
      //   name: 'My Leads',
      //   route: '/sales/my-leads',
      //   roles: ['*'],
      // },
      {
        name: 'Report',
        route: '/sales/report',
        roles: ['Super Admin', 'General Manager', 'Department Head', 'Hr Manager'],
      },
    ],
  },
  {
    name: 'Finance Request',
    icon: FinanceRequestSvg,
    route: '/finance-request',
    to: '/finance-request',
    roles: ['*'],
  },
  {
    name: 'CRM',
    icon: FinanceRequestSvg,
    route: '/customer-relationship-management',
    to: '/customer-relationship-management',
    roles: ['*'],
  },
  // {
  //   name: 'ERP',
  //   icon: ReportsSvg,
  //   route: '/erp',
  //   to: '/erp/subscriber',
  //   roles: ['Super Admin', 'General Manager', 'Department Head'],
  //   submenu: [
  //     {
  //       name: 'Բաժանորդի ստեղծում',
  //       route: '/erp/subscriber',
  //       roles: ['Super Admin', 'General Manager', 'Department Head'],
  //     },
  //     {
  //       name: 'Հասցեների ավելացում',
  //       route: '/erp/addresses',
  //       roles: ['Super Admin', 'General Manager', 'Department Head'],
  //     },
  //   ],
  // },
  {
    name: 'Quiz',
    icon: QuizSvg,
    route: '/quiz',
    roles: ['*'],
  },
];
